(function () {
  const hasGSAP = !!(window.gsap && window.ScrollTrigger);
  if (hasGSAP) gsap.registerPlugin(ScrollTrigger);
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Nav background on scroll
  const nav = document.getElementById('site-nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('is-scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  // Mobile menu
  const burger = document.getElementById('burger');
  const navMobile = document.getElementById('navMobile');
  if (burger && navMobile) {
    burger.addEventListener('click', () => {
      const open = navMobile.classList.toggle('open');
      burger.setAttribute('aria-expanded', open);
    });
    navMobile.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
      navMobile.classList.remove('open');
      burger.setAttribute('aria-expanded', false);
    }));
  }

  // Light rail — travels dawn to night with scroll position
  const marker = document.getElementById('railMarker');
  const rail = document.querySelector('.light-rail');
  function updateRail() {
    if (!rail || !marker) return;
    const h = document.documentElement;
    const max = h.scrollHeight - h.clientHeight;
    const progress = max > 0 ? h.scrollTop / max : 0;
    rail.style.backgroundPosition = `0% ${progress * 100}%`;
    marker.style.top = `${progress * 97}%`;
  }
  window.addEventListener('scroll', updateRail, { passive: true });
  updateRail();

  // Scroll reveals
  if (hasGSAP && !prefersReduced) {
    gsap.utils.toArray('.reveal').forEach((el) => {
      gsap.to(el, {
        opacity: 1, y: 0, duration: 1, ease: 'power3.out',
        scrollTrigger: { trigger: el, start: 'top 88%' }
      });
    });
  } else {
    document.querySelectorAll('.reveal').forEach(el => {
      el.style.opacity = 1;
      el.style.transform = 'none';
    });
  }

  // Magnetic buttons
  if (!prefersReduced) {
    document.querySelectorAll('.magnetic').forEach(btn => {
      btn.addEventListener('mousemove', e => {
        const r = btn.getBoundingClientRect();
        const x = e.clientX - r.left - r.width / 2;
        const y = e.clientY - r.top - r.height / 2;
        btn.style.transform = `translate(${x * 0.25}px, ${y * 0.35}px)`;
      });
      btn.addEventListener('mouseleave', () => { btn.style.transform = 'translate(0,0)'; });
    });
  }

  // ---- Cart (real Shopify AJAX Cart API) ----
  const cartBtn = document.getElementById('cartBtn');
  const cartCount = document.getElementById('cartCount');
  const drawerOverlay = document.getElementById('drawerOverlay');
  const drawerBody = document.getElementById('drawerBody');

  function openDrawer() {
    if (!drawerOverlay) return;
    drawerOverlay.classList.add('open');
    drawerOverlay.setAttribute('aria-hidden', 'false');
  }
  function closeDrawer() {
    if (!drawerOverlay) return;
    drawerOverlay.classList.remove('open');
    drawerOverlay.setAttribute('aria-hidden', 'true');
  }
  if (cartBtn) cartBtn.addEventListener('click', openDrawer);
  const drawerCloseBtn = document.getElementById('drawerClose');
  if (drawerCloseBtn) drawerCloseBtn.addEventListener('click', closeDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', e => { if (e.target === drawerOverlay) closeDrawer(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  function bindRemoveButtons() {
    if (!drawerBody) return;
    drawerBody.querySelectorAll('.drawer-remove').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.getAttribute('data-key');
        if (key) removeFromCart(key);
      });
    });
  }
  bindRemoveButtons();

  function renderCart(cart) {
    if (cartCount) {
      cartCount.textContent = cart.item_count;
      cartCount.classList.toggle('show', cart.item_count > 0);
    }
    if (!drawerBody) return;
    drawerBody.innerHTML = '';
    if (cart.item_count === 0) {
      const p = document.createElement('p');
      p.className = 'drawer-empty';
      p.textContent = 'Your cart is empty.';
      drawerBody.appendChild(p);
      return;
    }
    cart.items.forEach(item => {
      const row = document.createElement('div');
      row.className = 'drawer-item';
      const label = document.createElement('span');
      label.textContent = item.quantity > 1 ? `${item.product_title} × ${item.quantity}` : item.product_title;
      const removeBtn = document.createElement('button');
      removeBtn.className = 'drawer-remove';
      removeBtn.textContent = 'Remove';
      removeBtn.addEventListener('click', () => removeFromCart(item.key));
      row.appendChild(label);
      row.appendChild(removeBtn);
      drawerBody.appendChild(row);
    });
  }

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      renderCart(cart);
      return cart;
    } catch (err) {
      console.error('Cart fetch failed', err);
    }
  }

  async function addToCart(id, quantity) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: quantity || 1 }] })
      });
      if (res.ok) {
        await refreshCart();
        openDrawer();
      } else {
        const data = await res.json();
        alert(data.description || 'This item could not be added to your cart.');
      }
    } catch (err) {
      console.error('Add to cart failed', err);
    }
  }

  async function removeFromCart(key) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      await refreshCart();
    } catch (err) {
      console.error('Remove from cart failed', err);
    }
  }

  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', e => {
      e.preventDefault();
      const formData = new FormData(productForm);
      addToCart(formData.get('id'), 1);
    });
  }
})();
